import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-red.svg'
import _imports_1 from '@/app/ui/assets/svg/plus-active.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-89f1c790")

_pushScopeId("data-v-89f1c790")
const _hoisted_1 = { class: "w-10/12" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Nama Configurable Price ", -1)
const _hoisted_3 = { class: "w-10/12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, [
  /*#__PURE__*/_createTextVNode(" Deskripsi "),
  /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, " (optional)")
], -1)
const _hoisted_5 = { class: "xxl:pt-4 xxl:pb-4 textarea-address" }
const _hoisted_6 = { class: "text-12px text-right text-gray-lp-500 pt-2 pb-3" }
const _hoisted_7 = { class: "w-10/12" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-1" }, " Jenis Pengiriman ", -1)
const _hoisted_9 = { class: "w-10/12" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-1" }, " Jenis Barang yang Dikecualikan ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "border-b-2 w-full" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "text-xl text-black-lp-300 font-semibold" }, " Daftar Biaya Tambahan ", -1)
const _hoisted_13 = { class: "flex w-full flex-row gap-4 px-6" }
const _hoisted_14 = {
  key: 0,
  class: "w-4/12 font-semibold text-12px xxl:text-14px"
}
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "border-t" }, null, -1)
const _hoisted_17 = { class: "flex flex-row items-center" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center relative w-full" }, [
  /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border-t border-b border-r outline-none focus:shadow items-center py-2.5 xxl:py-3 text-12px xxl:text-14px px-3" }, " Kg ")
], -1)
const _hoisted_19 = { class: "flex flex-row items-center" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center relative w-full" }, [
  /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border-t border-b border-r outline-none focus:shadow items-center py-2.5 xxl:py-3 text-12px xxl:text-14px px-3" }, " Kg ")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center relative w-full" }, [
  /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border-t border-b border-r outline-none focus:shadow items-center py-2.5 xxl:py-3 text-12px xxl:text-14px px-3" }, " % ")
], -1)
const _hoisted_23 = {
  key: 1,
  class: "flex flex-row items-center"
}
const _hoisted_24 = {
  key: 0,
  class: "w-4/12"
}
const _hoisted_25 = { class: "flex flex-row items-center" }
const _hoisted_26 = { class: "w-1/12" }
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  style: {"height":"1.75rem","width":"1.75rem"},
  src: _imports_0,
  alt: "x"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "text-12px" }, " Hapus Daftar ", -1)
const _hoisted_29 = { class: "flex flex-row justify-between text-12px xxl:text-14px px-6" }
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "plus"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Tambah Daftar ")
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500" }, " Maksimal 10 ", -1)
const _hoisted_33 = { class: "flex flex-col text-12px border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Configurable Price "),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Anda bisa mengaktifkan status ini kapan saja ")
], -1)
const _hoisted_35 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_37 = { class: "ml-4" }
const _hoisted_38 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Status Configurable Price ", -1)
const _hoisted_40 = { class: "my-1 font-normal" }
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = { class: "capitalize" }
const _hoisted_43 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Tanggal Dibuat ", -1)
const _hoisted_45 = { class: "my-1 font-normal" }
const _hoisted_46 = { class: "text-gray-lp-500" }
const _hoisted_47 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Terakhir Diubah ", -1)
const _hoisted_49 = { class: "my-1 font-normal" }
const _hoisted_50 = { class: "text-gray-lp-500" }
const _hoisted_51 = { class: "inline-flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Select = _resolveComponent("Select")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_SelectBox = _resolveComponent("SelectBox")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      onTryAgain: _ctx.fetchDetail,
      title: "Edit Configurable Price"
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("input", {
            type: "text",
            placeholder: _ctx.dataDetail.configurablePriceName,
            class: 
            `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
              'bg-white'}`
          ,
            disabled: _ctx.isDisabled
          }, null, 10, ["placeholder", "disabled"])
        ]),
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
              _ctx.dataDetail.configurableHeavyWeight
                .heavy_weight_surcharge_description
             = $event)),
              maxlength: "500",
              class: "textarea-inside text-black-lp-300 w-full resize-none focus:outline-none"
            }, null, 512), [
              [_vModelText, 
              _ctx.dataDetail.configurableHeavyWeight
                .heavy_weight_surcharge_description
            ]
            ]),
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.dataDetail.configurableHeavyWeight
                .heavy_weight_surcharge_description?.length) + "/500 ", 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_MultipleSelectSearch, {
            options: _ctx.productOptions,
            modelValue: _ctx.productInclude,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.productInclude = $event)),
            modalTitle: "Pengecualian Produk",
            placeholder: "Masukan atau pilih produk",
            isLoading: _ctx.isLoadingProductOptions,
            onFilter: _ctx.filterProductOptions
          }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_MultipleSelectSearch, {
            options: _ctx.commodityListData,
            modelValue: _ctx.commodityExclude,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.commodityExclude = $event)),
            modalTitle: "Pengecualian Commodity",
            keyName: "commodity_name",
            keyValue: "commodity_code",
            isLoading: _ctx.isLoadingCommodity,
            placeholder: "Masukan atau pilih komoditas",
            onFilter: _ctx.fetchCommodityList
          }, null, 8, ["options", "modelValue", "isLoading", "onFilter"])
        ]),
        _createVNode(_component_DataWrapper, {
          label: "Tipe Heavyweight Surcharge",
          class: "w-10/12"
        }, {
          default: _withId(() => [
            _createVNode(_component_Select, {
              class: "w-full my-1.5",
              dataSelect: _ctx.typeHw,
              onOpenSelect: _ctx.onOpenTypeHwSelect,
              onCloseSelect: _ctx.onCloseTypeHwSelect,
              isOpenMenu: _ctx.typeHwSelect,
              onChooseSelect: _ctx.onSelectTypeHw,
              value: _ctx.dataDetail.heavyweightSurchargeType
            }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "value"])
          ]),
          _: 1
        }),
        _hoisted_11,
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("div", {
            class: 
            `${
              _ctx.isHwTypePercentage ? 'w-36' : 'w-56'
            } font-semibold text-12px xxl:text-14px`
          
          }, " Minimum Berat ", 2),
          _createVNode("div", {
            class: 
            `${
              _ctx.isHwTypePercentage ? 'w-36' : 'w-56'
            } font-semibold text-12px xxl:text-14px`
          
          }, " Maksimum Berat ", 2),
          _createVNode("div", {
            class: 
            `${
              _ctx.isHwTypePercentage ? 'w-36' : 'w-56'
            } font-semibold text-12px xxl:text-14px`
          
          }, " Biaya Tambahan ", 2),
          (_ctx.isHwTypePercentage)
            ? (_openBlock(), _createBlock("div", _hoisted_14, " Objek Biaya Tambahan "))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.additionalCosts, (cost, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: ["flex flex-row items-center gap-4 py-6 border-b", cost?.length > 1 ? 'pl-6' : 'px-6']
            }, [
              _createVNode("div", {
                class: `${_ctx.isHwTypePercentage ? 'w-36' : 'w-56'}`
              }, [
                _createVNode("div", _hoisted_17, [
                  _withDirectives(_createVNode("input", {
                    onInput: ($event: any) => (_ctx.onlyNumberAndFloat($event, index, 'weight_min')),
                    "onUpdate:modelValue": ($event: any) => (cost.weight_min = $event),
                    class: "py-2.5 xxl:py-3 border-gray-lp-400 px-4 rounded-l border focus:outline-none focus:shadow my-1 text-black-lp-300 w-10/12"
                  }, null, 40, ["onInput", "onUpdate:modelValue"]), [
                    [_vModelText, cost.weight_min]
                  ]),
                  _hoisted_18
                ])
              ], 2),
              _createVNode("div", {
                class: `${_ctx.isHwTypePercentage ? 'w-36' : 'w-56'}`
              }, [
                _createVNode("div", _hoisted_19, [
                  _withDirectives(_createVNode("input", {
                    onInput: ($event: any) => (_ctx.onlyNumberAndFloat($event, index, 'weight_max')),
                    "onUpdate:modelValue": ($event: any) => (cost.weight_max = $event),
                    class: "py-2.5 xxl:py-3 px-4 rounded-l border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-10/12"
                  }, null, 40, ["onInput", "onUpdate:modelValue"]), [
                    [_vModelText, cost.weight_max]
                  ]),
                  _hoisted_20
                ])
              ], 2),
              _createVNode("div", {
                class: `${_ctx.isHwTypePercentage ? 'w-36' : 'w-56'}`
              }, [
                (_ctx.isHwTypePercentage)
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      _withDirectives(_createVNode("input", {
                        onInput: ($event: any) => (
                  _ctx.onlyNumberAndFloat(
                    $event,
                    index,
                    'additional_cost_percentage'
                  )
                ),
                        "onUpdate:modelValue": ($event: any) => (cost.additional_cost_percentage = $event),
                        class: "py-2.5 xxl:py-3 px-4 rounded-l border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full"
                      }, null, 40, ["onInput", "onUpdate:modelValue"]), [
                        [_vModelText, cost.additional_cost_percentage]
                      ]),
                      _hoisted_22
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_23, [
                      _createVNode(_component_lp_input, {
                        modelValue: cost.additional_cost_flat,
                        "onUpdate:modelValue": ($event: any) => (cost.additional_cost_flat = $event),
                        prefix: "IDR",
                        format: _ctx.formatPrice,
                        onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                        placeholder: "e.g 20.000"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "format"])
                    ]))
              ], 2),
              (_ctx.isHwTypePercentage)
                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _createVNode(_component_SelectBox, {
                        class: "self-center",
                        modelValue: cost.object_additional_costs,
                        "onUpdate:modelValue": ($event: any) => (cost.object_additional_costs = $event),
                        dataSelect: _ctx.objectAdditionalCosts,
                        placeholder: "Pilih Objek Biaya"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "dataSelect"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_26, [
                _withDirectives(_createVNode("div", {
                  onClick: ($event: any) => (_ctx.onOpenRemoveConfirmation(index)),
                  onMouseenter: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args))),
                  onMouseleave: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args))),
                  class: "self-center cursor-pointer ml-3"
                }, [
                  _hoisted_27
                ], 40, ["onClick"]), [
                  [_vShow, _ctx.additionalCosts?.length > 1]
                ]),
                _createVNode(_component_OverlayPanel, {
                  ref: "deleteOp",
                  appendTo: "body",
                  style: {"width":"auto"}
                }, {
                  default: _withId(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }, 512)
              ])
            ], 2))
          }), 128))
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.createAddOn && _ctx.createAddOn(...args))),
            class: "cursor-pointer flex gap-4 text-red-lp-300"
          }, [
            _hoisted_30,
            _hoisted_31
          ]),
          _hoisted_32
        ]),
        _createVNode("div", _hoisted_33, [
          _hoisted_34,
          _createVNode("div", _hoisted_35, [
            _createVNode("div", {
              onClick: _cache[8] || (_cache[8] = () => _ctx.onOpenStatus()),
              class: 
              `toggle-switch inline-block cursor-pointer ${
                _ctx.isStatus ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
              }`
            
            }, [
              _hoisted_36
            ], 2),
            _createVNode("div", _hoisted_37, " Configurable Price " + _toDisplayString(_ctx.isStatus ? "Aktif" : "Tidak Aktif"), 1)
          ])
        ])
      ]),
      "sub-data": _withId(() => [
        _createVNode("div", _hoisted_38, [
          _hoisted_39,
          _createVNode("div", _hoisted_40, [
            _createVNode("div", _hoisted_41, [
              _createVNode("div", {
                class: 
                `rounded-full px-2 py-0 font-medium ${
                  _ctx.isStatus ? 'bg-green-lp-300' : 'bg-red-lp-600'
                } ${_ctx.isStatus ? 'text-green-lp-200' : 'text-red-lp-500'}`
              
              }, [
                _createVNode("span", _hoisted_42, _toDisplayString(_ctx.dataDetail.configurablePriceStatus.toLowerCase()), 1)
              ], 2)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_43, [
          _hoisted_44,
          _createVNode("div", _hoisted_45, _toDisplayString(_ctx.createdAt), 1),
          _createVNode("div", _hoisted_46, _toDisplayString(_ctx.dataDetail.configurablePriceCreatedBy), 1)
        ]),
        _createVNode("div", _hoisted_47, [
          _hoisted_48,
          _createVNode("div", _hoisted_49, _toDisplayString(_ctx.updatedAt), 1),
          _createVNode("div", _hoisted_50, _toDisplayString(_ctx.dataDetail.configurablePriceUpdatedBy), 1)
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_51, [
            _createVNode(_component_lp_button, {
              onClick: _ctx.onOpenSave,
              title: "Simpan",
              textColor: "white",
              color: "red-lp-100",
              disabled: _ctx.isValidated
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "loading", "onTryAgain"]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseStatus,
      onSubmit: _ctx.changeStatus,
      title: "Non-aktifkan Configurable Price",
      message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.",
      image: "warning",
      textSuccess: "Non-aktifkan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.openStatus]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCLoseRemoveConfirmation,
      onSubmit: _ctx.removeAddOn,
      title: "Hapus Biaya Tambahan",
      message: "Pastikan kembali, data biaya yang dihapus tidak bisa dikembalikan.",
      image: "warning",
      textSuccess: "Hapus",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.openRemoveConfirmation]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Perubahan Disimpan",
      message: 
      `Detail Versi “${_ctx.dataDetail.configurablePriceName}” berhasil diubah`
    ,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Configurable Price",
      message: 
      `Anda yakin akan menyimpan perubahan untuk Detail “${_ctx.dataDetail.configurablePriceName}“`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openModal]
    ])
  ], 64))
})